import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Alert
} from '@mui/material';
import userApi from '../../api/userApi';
import { toast } from 'react-toastify';

const ResetPasswordDialog = ({ open, onClose, user }) => {
    const { t } = useTranslation();
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [severity, setSeverity] = useState('success');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);
        try {
            await userApi.adminResetPassword({
                userId: user.id,
                newPassword: newPassword
            });
            toast.success(t('password_changed_success'));
            onClose();
            setNewPassword('');
        } catch (error) {
            setMessage(error.response?.data?.message || t('common.error'));
            setSeverity('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth dir="rtl">
            <form onSubmit={handleSubmit}>
                <DialogTitle>{t('common.admin_reset_password')}: {user?.userName}</DialogTitle>
                <DialogContent>
                    {message && (
                        <Alert severity={severity} sx={{ mb: 2 }}>
                            {message}
                        </Alert>
                    )}
                    <TextField
                        fullWidth
                        label={t('common.new_password')}
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        margin="normal"
                        required
                        autoFocus
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>{t('invoicesReport.vouchers.cancel')}</Button>
                    <Button type="submit" variant="contained" disabled={loading}>
                        {loading ? t('common.saving') : t('common.save')}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default ResetPasswordDialog;
